export default __webpack_public_path__ + "static/media/blue1.15eb24ad.png";